export class DashboardFilter {
  public readonly propertyName: string;
  public readonly displayName: string;
  public filterText: string;

  constructor(propertyName: string, displayName: string) {
    this.propertyName = propertyName;
    this.displayName = displayName;
  }
}
